import api from '@/services/api';

function findAllClaimsByCompanyId(companyId) {
  return api().get(`companies/${companyId}/claims`);
}
function findClaimDocumentsById(claimId) {
  return api().get(`claims/${claimId}/documents`);
}

function addDocumentsToClaimById(claimId, formData) {
  return api().post(`claims/${claimId}/documents`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export {
  addDocumentsToClaimById,
  findAllClaimsByCompanyId,
  findClaimDocumentsById,
};
